interface ImageSize {
  imageWidth: number
  minWidth: number
}

export type SizeType = 'column' | 'fullScreen' | 'fullWidth'

export const sizes: Record<SizeType, ImageSize[]> = {
  column: [
    {
      imageWidth: 750,
      minWidth: 480,
    },
    {
      imageWidth: 450,
      minWidth: 0,
    },
  ],
  fullScreen: [
    {
      imageWidth: 1920,
      minWidth: 1600,
    },
    {
      imageWidth: 1600,
      minWidth: 1200,
    },
    {
      imageWidth: 1200,
      minWidth: 1000,
    },
    {
      imageWidth: 1000,
      minWidth: 800,
    },
    {
      imageWidth: 800,
      minWidth: 768,
    },
    {
      imageWidth: 750,
      minWidth: 480,
    },
    {
      imageWidth: 450,
      minWidth: 0,
    },
  ],
  fullWidth: [
    {
      imageWidth: 1200,
      minWidth: 1000,
    },
    {
      imageWidth: 1000,
      minWidth: 800,
    },
    {
      imageWidth: 800,
      minWidth: 768,
    },
    {
      imageWidth: 750,
      minWidth: 480,
    },
    {
      imageWidth: 450,
      minWidth: 0,
    },
  ],
}
